import React, { useMemo, useState } from 'react';
import {
    Alert,
    AppBar,
    Avatar,
    Box,
    Button,
    Chip,
    CssBaseline,
    Divider,
    Drawer,
    FormControl,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Paper,
    Select,
    SelectChangeEvent,
    Snackbar,
    TextField,
    Toolbar,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import axios from 'axios';
import Lottie from 'lottie-react';
import MenuIcon from '@mui/icons-material/Menu';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import BarChartIcon from '@mui/icons-material/BarChart';
import PeopleIcon from '@mui/icons-material/People';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import PlaceIcon from '@mui/icons-material/Place';
import car from '../../lottie/car.json';
import Venta from '../venta/venta';
import Productos from '../productos/productos';
import ProductosxSurtir from '../productos/productosPorSurtir';
import Ventas from '../venta/Ventas';
import Tickets from '../venta/ticket';
import Graficas from '../venta/graficas';
import Usuarios from '../loggin/usuarios';

const drawerWidth = 270;

type Role = 1 | 2 | 3;

type MenuKey = 1 | 2 | 3 | 4 | 5 | 6 | 7;

interface MenuItemType {
    key: MenuKey;
    label: string;
    icon: JSX.Element;
}

const menuItems: MenuItemType[] = [
    { key: 1, label: 'Venta', icon: <ShoppingCartIcon color="secondary" /> },
    { key: 2, label: 'Productos', icon: <ShoppingBasketIcon color="secondary" /> },
    { key: 3, label: 'Por surtir', icon: <AddShoppingCartIcon color="secondary" /> },
    { key: 4, label: 'Ventas', icon: <StorefrontIcon color="secondary" /> },
    { key: 5, label: 'Tickets', icon: <ConfirmationNumberIcon color="secondary" /> },
    { key: 6, label: 'Graficas', icon: <BarChartIcon color="secondary" /> },
    { key: 7, label: 'Usuarios', icon: <PeopleIcon color="secondary" /> },
];

const rolePermissions: Record<Role, MenuKey[]> = {
    1: [1, 2, 3, 4, 5, 6, 7],
    2: [1, 5],
    3: [2, 3],
};

function Header() {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [status, setStatus] = useState<MenuKey>(1);
    const [user, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [locations, setLocations] = useState('');
    const [loginValidate, setLoginValidate] = useState(false);
    const [rol, setRol] = useState<Role>(1);
    const [errorOpen, setErrorOpen] = useState(false);

    const permittedItems = useMemo(() => rolePermissions[rol] || [], [rol]);

    const selectedComponent = useMemo(() => {
        switch (status) {
            case 1:
                return <Venta />;
            case 2:
                return <Productos />;
            case 3:
                return <ProductosxSurtir />;
            case 4:
                return <Ventas />;
            case 5:
                return <Tickets />;
            case 6:
                return <Graficas />;
            case 7:
                return <Usuarios />;
            default:
                return <Venta />;
        }
    }, [status]);

    const showLoginError = () => {
        setErrorOpen(true);
    };

    const setInitialScreenForRole = (role: Role) => {
        const firstOption = rolePermissions[role][0] as MenuKey;
        setStatus(firstOption);
    };

    const handleChangeLocation = (event: SelectChangeEvent) => {
        setLocations(event.target.value);
    };

    const loggin = () => {
        if (!user || !password || !locations) {
            showLoginError();
            return;
        }

        axios({
            method: 'get',
            url: '/login.php?usuario=' + user + '&contraseña=' + password,
        })
            .then((response: any) => {
                if (response?.data?.[0]?.usuario) {
                    const roleResponse = Number(response.data[0].idrol) as Role;
                    const normalizedRole: Role = [1, 2, 3].includes(roleResponse) ? roleResponse : 1;
                    setRol(normalizedRole);
                    setInitialScreenForRole(normalizedRole);
                    setLoginValidate(true);
                    sessionStorage.setItem('lugar', locations);
                    sessionStorage.setItem('user', user);
                    sessionStorage.setItem('rol', String(normalizedRole));
                    if (!isDesktop) {
                        setDrawerOpen(false);
                    }
                } else {
                    showLoginError();
                }
            })
            .catch(() => {
                showLoginError();
            });
    };

    const salir = () => {
        setLoginValidate(false);
        setDrawerOpen(false);
        setPassword('');
    };
//sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}
    const drawerContent = (
        <Box
            sx={{
                height: '100%',
                background: 'linear-gradient(180deg, #111111 0%, #1F2937 100%)',
                color: '#FFFFFF',
                minWidth: '100vh',
                backgroundColor: 'background.default',
            }}
        >
            <Box sx={{ px: 2.5, py: 2 }}>
                <Typography variant="subtitle2" sx={{ opacity: 0.75 }}>
                    Panel principal
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    Cluth y Frenos Carrasco
                </Typography>
            </Box>
            <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)' }} />
            <List>
                {menuItems
                    .filter((item) => permittedItems.includes(item.key))
                    .map((item) => (
                        <ListItem key={item.key} disablePadding sx={{ px: 1, py: 0.5 }}>
                            <ListItemButton
                                onClick={() => {
                                    setStatus(item.key);
                                    if (!isDesktop) {
                                        setDrawerOpen(false);
                                    }
                                }}
                                sx={{
                                    borderRadius: 2,
                                    backgroundColor: status === item.key ? 'rgba(245, 158, 11, 0.15)' : 'transparent',
                                    '&:hover': {
                                        backgroundColor: 'rgba(245, 158, 11, 0.22)',
                                    },
                                }}
                            >
                                <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.label} />
                            </ListItemButton>
                        </ListItem>
                    ))}
            </List>
        </Box>
    );

    if (!loginValidate) {
        return (
            <Grid
                container
                sx={{
                    minHeight: '100vh',
                    background:
                        'radial-gradient(circle at 10% 20%, rgba(251, 191, 36, 0.24), transparent 45%), radial-gradient(circle at 80% 0%, rgba(14, 165, 233, 0.2), transparent 38%), linear-gradient(135deg, #F8FAFC 0%, #E2E8F0 100%)',
                    p: { xs: 2, sm: 4 },
                }}
                alignItems="center"
                justifyContent="center"
            >
                <Grid item xs={12} lg={10}>
                    <Paper
                        elevation={12}
                        sx={{
                            overflow: 'hidden',
                            borderRadius: 4,
                            border: '1px solid rgba(15, 23, 42, 0.08)',
                            backdropFilter: 'blur(3px)',
                        }}
                    >
                        <Grid container>
                            <Grid
                                item
                                xs={12}
                                md={6}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    p: { xs: 2, sm: 4 },
                                    background:
                                        'linear-gradient(145deg, #0F172A 0%, #1E293B 50%, #334155 100%)',
                                    color: '#fff',
                                }}
                            >
                                <Box sx={{ width: '100%', maxWidth: 420 }}>
                                    <Lottie animationData={car} loop />
                                    <Typography variant="h4" sx={{ fontWeight: 800, mt: 1 }}>
                                        Bienvenido
                                    </Typography>
                                    <Typography sx={{ opacity: 0.85 }}>
                                        Controla ventas, inventario y tickets desde un solo lugar.
                                    </Typography>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6} sx={{ p: { xs: 3, sm: 5 } }}>
                                <Typography variant="h5" sx={{ fontWeight: 800, color: '#0F172A' }}>
                                    Iniciar sesion
                                </Typography>
                                <Typography sx={{ color: '#475569', mb: 3 }}>
                                    Ingresa tus datos para acceder al sistema.
                                </Typography>

                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Usuario"
                                            value={user}
                                            onChange={(event) => setUser(event.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <PersonIcon sx={{ color: '#64748B' }} />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            type={showPassword ? 'text' : 'password'}
                                            label="Contrasena"
                                            value={password}
                                            onChange={(event) => setPassword(event.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <LockIcon sx={{ color: '#64748B' }} />
                                                    </InputAdornment>
                                                ),
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                                            {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel id="location-select-label">Sucursal</InputLabel>
                                            <Select
                                                labelId="location-select-label"
                                                value={locations}
                                                onChange={handleChangeLocation}
                                                label="Sucursal"
                                                startAdornment={
                                                    <InputAdornment position="start">
                                                        <PlaceIcon sx={{ color: '#64748B', ml: 1 }} />
                                                    </InputAdornment>
                                                }
                                            >
                                                <MenuItem value={1}>Tepe</MenuItem>
                                                <MenuItem value={2}>Ozumba</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                            fullWidth
                                            size="large"
                                            variant="contained"
                                            onClick={loggin}
                                            sx={{
                                                py: 1.4,
                                                fontWeight: 700,
                                                background: 'linear-gradient(90deg, #0EA5E9 0%, #2563EB 100%)',
                                            }}
                                        >
                                            Entrar al panel
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>

                <Snackbar
                    open={errorOpen}
                    autoHideDuration={3500}
                    onClose={() => setErrorOpen(false)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert severity="error" variant="filled" onClose={() => setErrorOpen(false)}>
                        Credenciales invalidas o datos incompletos.
                    </Alert>
                </Snackbar>
            </Grid>
        );
    }

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: '#F1F5F9' }}>
            <CssBaseline />
            <AppBar
                position="fixed"
                color="primary"
                sx={{
                    zIndex: (themeValue) => themeValue.zIndex.drawer + 1,
                    background: 'linear-gradient(90deg, #020617 0%, #0F172A 100%)',
                }}
            >
                <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {!isDesktop && (
                            <IconButton color="secondary" onClick={() => setDrawerOpen(true)} edge="start">
                                <MenuIcon />
                            </IconButton>
                        )}
                        <Avatar sx={{ bgcolor: '#0EA5E9', width: 34, height: 34 }}>C</Avatar>
                        <Typography sx={{ fontWeight: 700, display: { xs: 'none', sm: 'block' } }}>
                            Cluth y Frenos Carrasco
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Chip label={`Rol ${rol}`} color="secondary" size="small" />
                        <IconButton color="secondary" onClick={salir} title="Salir">
                            <PowerSettingsNewIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            <Drawer
                variant={isDesktop ? 'permanent' : 'temporary'}
                open={isDesktop || drawerOpen}
                onClose={() => setDrawerOpen(false)}
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        borderRight: 'none',
                        mt: isDesktop ? 8 : 0,
                        height: isDesktop ? 'calc(100% - 64px)' : '100%',
                    },
                }}
            >
                {drawerContent}
            </Drawer>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    width: '100%',
                    p: { xs: 1.5, sm: 2.5, md: 3 },
                    mt: 8,
                }}
            >
                {selectedComponent}
            </Box>
        </Box>
    );
}

export default Header;
